/**
 * 中文（zh-CN）
 */

import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN'

import publish from './publish/zh.CN'
import personal from './personal/zh.CN'
import order from './order/zh.CN'
import customProduct from './customProduct/zh.CN'
import index from './index/zh.CN'
import message from './message/zh.CN'
export default {
  ...zhCNLocale,
  currency: {
    product: '产品',
    inStock: '现货',
    myProduct: '我的产品',
    listings: 'listings',
    wishList: '心愿清单',
    allOrder: '所有订单',
    store: '店铺',
    personalCenter: '个人中心',
    payment: '付款',
    address: '地址',
    accountSettings: '账号设置',
    logOut: '注销',
    cancel: '取消',
    submit: '提交',
    selectAll: '全选',
    confirmOrder: '确认订单',
    back: '返回',
    sortBy: '排序',
    newest: '最新的',
    highestInventory: '最高库存',
    highestSales: '最高销售额',
    highestPrice: '最高价格',
    lowestPrice: '最低价格',
    customProduct: '定制产品',
    home: '现货',
    newIn: '新品',
    deleteTip: '您确定要删除所选产品吗？',
    delete: '删除'
  },
  // 语言
  lang: {
    english: '英语',
    chinese: '中文',
    spanish: '西班牙语',
    japanese: '日语',
    portuguese: '葡萄牙语',
    french: '法语',
    russian: '俄语',
    arabic: '阿拉伯语',
    german: '德语',
    italian: '意大利语',
    vietnam: '越语',
    turkey: '土耳其语',
    korean: '韩语',
    thai: '泰语',
    dutch: '荷兰语',
    hebrew: '希伯来语',
    indonesian: '印度尼西亚语'
  },
  msg: {
    pleaseAddStoreFirst: '请先添加店铺',
    addedToProductListSuccessfully: '添加到产品列表成功',
    success: '成功'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {
    category: '品类',
    search: '搜索',
    searchingFor: '用逗号或空格分隔多个搜索',
    shippingFrom: '发货地',
    fabric: '材质',
    price: '价格',
    inventory: '库存',
    newest: '最新',
    sales: '销量',
    min: '最小',
    max: '最大',
    recentSearches: '最近搜索',
    hotSearches: '热门搜索'
  },
  // 商品详情页
  productDetail: {
    product: '产品',
    detail: '详情',
    itemNo: '编号',
    processingTime: '处理时间',
    shippingCost: '运费',
    paymentMethod: '支付方式',
    sizeGuide: '尺码表',
    color: '颜色',
    size: '尺寸',
    viewAllVariants: '查看所有变体',
    allVariants: '所有变体',
    shipFrom: '发货地',
    addToCart: '加入购物车',
    listToStore: '刊登',
    addToWishList: '加入愿望清单',
    description: '描述',
    return: '退货',
    refundPolicy: '退款政策',
    shipping: '运输',
    image: '图片',
    action: '操作',
    // 选项卡/shipping
    packingSize: '包装尺寸',
    packingWeight: '包装重量',
    shippingFrom: '发货地',
    shippingTo: '运送地',
    qty: '数量',
    maximum: '最大库存:',
    shippingMethod: '运输方式',
    estimatedDeliveryTime: '预计交货时间',
    businessDays: '工作日',
    sizeChart: '尺码表',
    deliveryTime: '交货时间',
    outOfStockTips: '对不起，缺货了！',
    pleaseSelected: '请选择',
    customerReviews: '客户评论',
    writeAReview: '写评论'
  },
  // 购物车
  shoppingCart: {
    shoppingCart: '购物车',
    topTip: '选择同一仓库中的产品下单。'
  },
  // 确认订单
  confirmOrder: {
    shippingAddress: '送货地址',
    addNewAddress: '新增地址',
    selectAnotherAddress: '选择其他地址',
    editTheAddress: '修改地址',
    remark: '备注',
    unitPrice: '单价',
    totalPayable: '应付总额',
    itemSubtotal: '项目小计',
    subtotal: '项目小计',
    shippingSubtotal: '运费小计',
    promotion: '折扣减免',
    grandTotal: '总计',
    creditCard: '信用卡',
    balance: '余额',
    payNow: '支付',
    commonProblem: '常见问题',
    emailVerification: '邮箱验证',
    verificationTitle: '验证码已发送到您的电子邮件',
    verification: '验证',
    seconds: '秒',
    laterGetPasswordAgain: '稍后再获取密码',
    sendAgain: '再次发送'
  },
  // 账号设置弹窗
  setting: {
    setting: '设置',
    fullName: '姓名',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    notVerified: '未验证',
    change: '修改',
    codeSend: '验证码已发送到您的电子邮件' // 'A Verification code has been sent to your email'
  },

  // 张丰
  ...personal,

  // 孙泽严
  ...publish,
  ...order,
  ...customProduct,

  ...index,
  ...message
}
